var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { themeGet, space, left, right, color, boxShadow, display, position, width, height, flex, textAlign, fontSize, border, borderRadius, background, maxHeight, maxWidth, top, } from 'styled-system';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import arrow from '../assets/icons/arrow-right.svg';
import { isTouchDevice } from '../../common/DeviceDetector';
import { useLocalization } from '../providers/LocaleProvider';
import { Heading } from './Text';
var ICON_SIZE = '24px';
var SECTION_POSITION = ['-16px', '-24px', '-48px', '-64px'];
var AccordionSectionContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n"])), position, width, flex);
AccordionSectionContainer.defaultProps = {
    flex: 'none',
    position: 'relative',
    width: '100%',
};
var SectionBorder = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), height, position, color, display, left, right);
SectionBorder.defaultProps = {
    position: 'absolute',
    height: '1px',
    bg: 'gray.4',
    display: 'block',
    left: SECTION_POSITION,
    right: SECTION_POSITION,
};
var SectionTopBorder = styled(SectionBorder)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  top: 0;\n"], ["\n  top: 0;\n"])));
var SectionBottomBorder = styled(SectionBorder)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  bottom: 0;\n"], ["\n  bottom: 0;\n"])));
var AccordionSectionTitle = styled(Heading)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  cursor: pointer;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  cursor: pointer;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ",
    ";\n"])), position, display, width, textAlign, space, boxShadow, function (props) {
    return props.active && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      /* The support is not that good, but most of the modern mobile browsers are supporting this */\n      /* https://caniuse.com/#feat=css-media-interaction */\n      @media not all and (pointer: coarse) {\n        &:hover {\n          color: ", ";\n        }\n      }\n    "], ["\n      /* The support is not that good, but most of the modern mobile browsers are supporting this */\n      /* https://caniuse.com/#feat=css-media-interaction */\n      @media not all and (pointer: coarse) {\n        &:hover {\n          color: ", ";\n        }\n      }\n    "])), themeGet('colors.brand.normal')(props));
});
AccordionSectionTitle.defaultProps = __assign(__assign({}, Heading.defaultProps), { as: 'h3', position: 'relative', display: 'block', textAlign: 'left', width: '100%', m: 0, px: 0, pt: 'sp_16', pb: ['sp_16', null, 'sp_8'], boxShadow: [null, null, 'bottom'], fontSize: ['fs_16', null, null, 'fs_18'], lineHeight: ['lh_24', null, null, 'lh_32'] });
var AccordionSectionButton = styled.button(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  cursor: pointer;\n  font: inherit;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n"], ["\n  cursor: pointer;\n  font: inherit;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ",
    "\n"])), background, borderRadius, color, border, textAlign, fontSize, space, function () {
    return isTouchDevice() && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      outline: none;\n    "], ["\n      outline: none;\n    "])));
});
AccordionSectionButton.defaultProps = {
    borderRadius: 0,
    background: 'none',
    color: 'gray.16',
    fontSize: ['fs_16', 'fs_18', null, 'fs_20'],
    border: 'none',
    textAlign: 'left',
    p: 0,
    m: 0,
};
var AccordionSectionArrow = styled.img(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  transform: translateY(-50%) rotate(", "deg);\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  transform: translateY(-50%) rotate(", "deg);\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) { return (props.down ? 90 : -90); }, position, width, height, maxWidth, maxHeight, top, right);
AccordionSectionArrow.defaultProps = {
    src: arrow,
    alt: '',
    position: 'absolute',
    width: ICON_SIZE,
    maxWidth: ICON_SIZE,
    height: ICON_SIZE,
    maxHeight: ICON_SIZE,
    right: 0,
    top: '50%',
};
var AccordionSectionContent = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n"])), position, flex, width);
AccordionSectionContent.defaultProps = {
    position: 'relative',
    flex: 'none',
    width: '100%',
};
var AccordionSection = function (_a) {
    var isCollapsible = _a.isCollapsible, children = _a.children, title = _a.title, isExpanded = _a.isExpanded, onTitleClick = _a.onTitleClick, hasTopBorder = _a.hasTopBorder, sectionName = _a.sectionName, renderTitle = _a.renderTitle, displayBorder = _a.displayBorder;
    var t = useLocalization().t;
    var expanded = isExpanded(sectionName);
    return (React.createElement(AccordionSectionContainer, { "data-section-name": sectionName, "data-testid": "accordion-section" },
        renderTitle({
            'data-testid': 'accordion-title',
            onClick: function () { return isCollapsible && onTitleClick(sectionName); },
            active: isCollapsible,
            children: (React.createElement(React.Fragment, null,
                hasTopBorder && React.createElement(SectionTopBorder, { display: displayBorder }),
                isCollapsible ? (React.createElement(React.Fragment, null,
                    React.createElement(AccordionSectionButton, { role: "button", "aria-expanded": expanded, "aria-controls": sectionName, id: "accordion-section-" + sectionName, "data-testid": "accordion-button" }, title),
                    React.createElement(AccordionSectionArrow, { "data-testid": "expand-arrow", down: !expanded, alt: t('h24_expand_arrow') }))) : (title),
                React.createElement(SectionBottomBorder, { display: displayBorder }))),
        }),
        expanded && (React.createElement(React.Fragment, null,
            React.createElement(AccordionSectionContent, { id: sectionName, role: "region", "aria-labelledby": "accordion-section-" + sectionName, "data-testid": "accordion-section-content" }, children),
            React.createElement(SectionBottomBorder, { display: displayBorder })))));
};
AccordionSection.propTypes = {
    isExpanded: PropTypes.func,
    isCollapsible: PropTypes.bool,
    onTitleClick: PropTypes.func,
    sectionName: PropTypes.string,
    renderTitle: PropTypes.func,
    displayBorder: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]),
};
AccordionSection.defaultProps = {
    renderTitle: function (props) { return React.createElement(AccordionSectionTitle, __assign({}, props)); },
    isCollapsible: false,
};
export default AccordionSection;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
